import { Injectable } from '@angular/core';

export enum NewRelicCustomAction {
  LOGOUT_ACTION = 'Logout',
  API_ERROR_ACTION = 'ApiError',
}

export interface NewRelicBaseActionData extends Record<string, string | number> {
  action: NewRelicCustomAction;
  environment: string;
  ip: `${number}.${number}.${number}.${number}` | 'unknown';
  userId: string;
  callingContext: string;
  stackTrace: string;
}

export interface NewRelicLogoutActionData extends NewRelicBaseActionData {
  action: NewRelicCustomAction.LOGOUT_ACTION;
  reason: 'user-initiated' | 'profile-list';
}

export interface NewRelicApiErrorActionData extends NewRelicBaseActionData {
  action: NewRelicCustomAction.API_ERROR_ACTION;
  apiUrl: string;
  responseCode: number;
}

export type NewRelicAction = NewRelicLogoutActionData | NewRelicApiErrorActionData;

@Injectable()
export abstract class AbstractNewRelicService {
  public abstract createBasicAction(callingContext: string, stackTrace: string): NewRelicBaseActionData;
  public abstract sendAction<A extends NewRelicCustomAction, T extends NewRelicAction & { action: A }>(
    action: A,
    data: Omit<T, 'action'>
  ): void;
  public abstract noticeError(error: string | Error): void;
}
